import { useMediaLoader } from '../../hooks/useMediaLoader';
import styles from './ResultQuiz.module.css';
import { motion } from 'motion/react';

export const ResultQuiz = ({ correctVar }) => {
  const { comment, varImgUrl } = correctVar || {};

  const arrTitle = comment?.trim()?.split(' ');

  const { isFullyLoaded } = useMediaLoader(varImgUrl, 'image');

  if (varImgUrl && !isFullyLoaded) {
    return null;
  }

  return (
    <div
      className={styles.wrapper}
      style={{
        flexDirection: varImgUrl && 'row',
        justifyContent: varImgUrl && 'space-between',
      }}
    >
      {varImgUrl && (
        <motion.div
          initial={{ y: '100vh' }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5 }}
          className={styles.imgBlock}
        >
          <img src={varImgUrl} alt="" className={styles.playerImg} />
        </motion.div>
      )}

      {comment && (
        <div className={styles.titleWrapper}>
          <motion.div
            initial={{ x: '100vw' }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            className={styles.secondName}
          >
            {arrTitle[0]}
          </motion.div>
          <motion.div
            initial={{ x: '-100vw' }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            className={styles.firstName}
          >
            {arrTitle[1]}
          </motion.div>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.4, 1] }}
            transition={{
              duration: 0.8,
              delay: 0.6,
              times: [0, 0.75, 1],
              ease: ['easeIn', 'easeOut'],
            }}
            className={styles.number}
          >
            {arrTitle[2]}
          </motion.div>
        </div>
      )}
    </div>
  );
};
